import { type FC } from "react";
import { ToolUsed } from "../../../core/types";

interface ChatMessageListToolAttributionProps {
  tools: ToolUsed[];
}

// Persistent attribution rendered beneath a final assistant answer, crediting
// the Tool functions that produced it (LAS-1350). The transient in-flight chip
// (ChatMessageListToolCallItem) fades out once the answer arrives; this is its
// permanent counterpart, driven by the `tools_used` metadata on the message.
const ChatMessageListToolAttribution: FC<ChatMessageListToolAttributionProps> = ({ tools }) => {
  const names = tools
    // Credit the originating Tool by name; fall back to the localized label and
    // finally the stable function identifier. Strip any HTML tags.
    .map((tool) => (tool.tool_name || tool.label || tool.function || "").replace(/<[^>]*>/g, "").trim())
    .filter((name) => name.length > 0)
    // The backend deduplicates by `function`, but several functions can share a
    // Tool — dedupe the resolved names so a Tool is credited once.
    .filter((name, index, all) => all.indexOf(name) === index);

  if (names.length === 0) {
    return null;
  }

  return (
    <div className="self-end text-xs text-gray-400" data-testid="tool-attribution">
      {names.join(", ")}
    </div>
  );
};

export default ChatMessageListToolAttribution;
